<template lang="pug">
v-flex.game(sm6 md4 lg3 :id="`game-${ game.id }`")
  v-card
    v-card-title
      folder-icon(:folderId="game.folderId")
      span.ml-1 {{ game.title || "[No title]" }}
    v-responsive
      img(:src="game.coverArt")
    v-card-actions
      v-btn(small outlined @click="$router.push({ name: 'gameEditor', params: { gameId: game.id }})") Edit
      v-btn(small text color="error" @click="showDeleteDialog = true") Delete
      v-dialog(v-model="showDeleteDialog" max-width="500")
        v-card
          v-card-title.subtitle-1 Delete "{{ game.title }}"?
          v-card-text.caption This action cannot be undone.
          v-card-actions
            v-spacer
            v-btn(text small @click="showDeleteDialog = false") Cancel
            v-btn(text small color="error" @click="destroyGame(game)") Delete
</template>
<script>
  import { mapActions } from 'vuex'
  import FolderIcon from '../icons/FolderIcon.vue'
  export default {
    props: {
      game: {
        required: true
      }
    },
    components: { FolderIcon },
    data() {
      return {
        showDeleteDialog: false
      }
    },
    methods: mapActions(["destroyGame"]),
  }
</script>
<style scoped>
  dd {
    font-size: .8em;
  }
</style>